import { Injectable } from '@angular/core';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { LocalNotifications } from '@capacitor/local-notifications';
import { PushNotification, PushNotificationActionPerformed, PushNotifications } from '@capacitor/push-notifications';
import { Platform } from '@ionic/angular';
import { FirebaseService } from '../firebase/firebase.service';
import { User } from '../../models/user.model';
import { Store } from '@ngrx/store';
import * as fromUserActions from 'src/app/shared/store/actions';
import { filter, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private readonly platform: Platform, private readonly firebaseService: FirebaseService, private readonly store: Store<{ userData: { data: User } }>) { }


  initializeFCM() {
    if (!this.platform.is('desktop') && !this.platform.is('mobileweb')) {
      this.platform.ready().then(() => {
        this.requestPermissions();
        PushNotifications.addListener('pushNotificationReceived', (notification: PushNotification) => {
          console.log('Notificación recibida:', notification);
          LocalNotifications.schedule({
            notifications: [
              {
                title: notification.title!,
                body: notification.body!,
                id: new Date().getTime(),
                schedule: { at: new Date(Date.now() + 1000) },
  
                sound: null!,
                attachments: null!,
                actionTypeId: '',
                extra: null
              }
            ]
          });
        });
  
        PushNotifications.addListener('pushNotificationActionPerformed', (action: PushNotificationActionPerformed) => {
          console.log('Notificación tocada:', action);
          // Manejar la acción aquí
        });
      });
    }

  }

  requestPermissions() {
    PushNotifications.requestPermissions().then(permission => {
      if (permission.receive === 'granted') {
        this.registerForPushNotifications();
      }
    });
  }

  async registerForPushNotifications() {
    await PushNotifications.register();
    const token = await this.getFCMToken();
    if (token) {
      console.log('paso por aqui');
        const response = await this.saveDeviceFCMToken(token);
        console.log('Token guardado:', response);
    }
}

  async getFCMToken() {
    try {
      const { token } = await FirebaseMessaging.getToken();
      if (token) {
        console.log('Token de FCM:', token);
        return token;
      } else {
        console.log('No se pudo obtener el token.');
        return null;
      }
    } catch (error) {
      console.error('Error al obtener el token de FCM:', error);
      return null
    }
  }

  async saveDeviceFCMToken(token: string): Promise<void> {
    this.store.select('userData')
      .pipe(filter((response) => !!response.data), take(1))
      .subscribe((userData) => {
        const newData = { fcmDeviceId: token };
        this.store.dispatch({ type: fromUserActions.UPDATE_USER, data: newData });
        return this.firebaseService.updateDoc('users', userData.data.id!, newData);
      });
}
}
